export default __webpack_public_path__ + "static/media/abogado.40214ee6.png";